import { translationKey } from '../../i18n';
import { localize } from '../../i18n';
import SingleLineText from '../../components/ui/SingleLineText';
import React, { useLayoutEffect, useState } from 'react';
import { Box } from '@mui/material';
import BottomSheet from '../../components/BottomSheet';
import AppButton from '../../components/ui/AppButton';
import AppField from '../../components/ui/AppField';

export function MedicationNameEditor({
    value,
    onChange,
    autoFocus = false,
}) {
    return (
        <AppField
            label={localize("약 이름")}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            autoFocus={autoFocus}
            fullWidth
            inputProps={{ maxLength: 40 }}
            sx={{
                '& .MuiOutlinedInput-input': { fontWeight: 800 },
            }}
        />
    );
}

export default function MedicationNameEditSheet({
    open,
    value,
    onClose,
    onSave,
    title = translationKey('약 이름 수정'),
}) {
    const [draft, setDraft] = useState(value || '');

    useLayoutEffect(() => {
        if (open) setDraft(value || '');
    }, [open, value]);

    const save = () => {
        const nextName = draft.trim();
        if (!nextName) return;
        onSave(nextName);
        onClose();
    };

    return (
        <BottomSheet open={open} onClose={onClose} footer={
                <>
                    <AppButton
                        fullWidth
                        disabled={!draft.trim()}
                        onMouseDown={(event) => event.preventDefault()}
                        onClick={save}
                        sx={{ py: 1.45, fontSize: '1.05rem', fontWeight: 750 }}
                    >{localize("저장")}</AppButton>
                </>
        }>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <SingleLineText sx={{ fontSize: '1.15rem', fontWeight: 750, color: '#1a1a1a' }}>
                    {localize(title)}
                </SingleLineText>
                <MedicationNameEditor
                    value={draft}
                    onChange={setDraft}
                />
            </Box>
        </BottomSheet>
    );
}
